import { Failure } from '@mrhenry/failure';
import { html, TemplateResult } from 'lit';
import { live } from 'lit/directives/live.js';
import { staticText } from '../../../static-text';
import { Dispatcher } from '../../../types/booking-request';
import { WPACFLink } from '../../../types/wp-data';

export function agreeToTermsInput(
	agreeToTerms: boolean,
	dispatch: Dispatcher,
	assetUrl: string,
	termsLink: WPACFLink,
	agreeToTermsFailure?: Failure
): TemplateResult {
	const changeHandler = ( e: InputEvent ) => {
		if ( e.target !== e.currentTarget ) {
			return;
		}

		if ( !( e.target instanceof HTMLInputElement ) ) {
			throw new Error( 'e.target should be instanceof HTMLInputElement' );
		}

		if ( !e.target.checked ) {
			dispatch( {
				type: 'UPDATE_AGREE_TO_TERMS',
				agreeToTerms: e.target.checked,
				agreeToTermsFailure: Failure.from( staticText.agreeToTermsFailureMessage ),
			} );

			return;
		}

		dispatch( {
			type: 'UPDATE_AGREE_TO_TERMS',
			agreeToTerms: e.target.checked,
		} );
	};

	let failure = html``;
	if ( Failure.isFailure( agreeToTermsFailure ) ) {
		failure = html`
			<div>
				<p class="form__field-validation-error theme-color-error">
					${agreeToTermsFailure?.message}
				</p>
			</div>
		`;
	}

	return html`
		<div class="form__row">
			<div class="form__checkbox type-d">
				<input
					.checked=${live( agreeToTerms )}
					@change=${changeHandler}
					class="form__checkbox__input"
					id="agree-to-terms"
					name="agree-to-terms"
					type="checkbox"
				/>

				<label
					class="form__checkbox__label"
					for="agree-to-terms"
				>
					${staticText.iAgreeToThe}
				</label>

				<a
					href=${termsLink.url}
					target="_blank"
				>
					${termsLink.title}
				</a>
			</div>

			${failure}
		</div>
	`;
}
